import React from 'react';
import { useStaticIntl } from '@tribeplatform/react-components/i18n';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useBlock } from '../../hooks/index.js';
import { wrapperStylesFactory } from '../HeroBanner/utils.js';
import { CodeEditorFieldPicker } from './HtmlCodeEditor/CodeEditorFieldPicker.js';
export const HtmlScriptBlockSettings = () => {
    const { block: { props: { html, wrapper }, }, upsertProp, } = useBlock();
    const wrapperItems = useStaticIntl(wrapperStylesFactory);
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(CodeEditorFieldPicker, { name: "html", label: "Html", defaultLanguage: "html", value: html, onChange: value => {
                upsertProp('html', value);
            } }),
        React.createElement(FormControl.Select, { name: "wrapper", label: "Wrapper", value: wrapper, onChange: (value) => {
                upsertProp('wrapper', value);
                return value;
            }, items: wrapperItems })));
};
//# sourceMappingURL=Settings.js.map